import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',{attrs:{"title":'Welcome to your ' + _vm.household.name + ' dashboard!'}},[_c('span',{staticClass:"subtitle-1"},[_vm._v(" Add an app to your household by clicking "),_c(VBtn,{attrs:{"rounded":"","color":"primary","to":'/h/' + this.household.id + '/add'}},[_c(VIcon,{attrs:{"left":""}},[_vm._v("mdi-plus")]),_vm._v(" Add App")],1),_c('br'),_vm._v(" Be sure to check back every once in a while as we are always adding more apps! ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }